import i18next from "@/i18n";
import type { TOptions } from "i18next";

export const NOTIFICATIONS = {
  ERROR_DEFAULT: { message: i18next.t("toast.error.default"), type: "error" },

  /** login, account */
  // warning
  WARN_CURRENT_PASSWORD: { message: i18next.t("toast.account.warn.current_password"), type: "warning" },
  WARN_NEW_PASSWORD: { message: i18next.t("toast.account.warn.new_password"), type: "warning" },
  WARN_CONFIRMED_PASSWORD: { message: i18next.t("toast.account.warn.confirmed_password"), type: "warning" },
  WARN_LOGIN_PASSWORD: { message: i18next.t("toast.account.warn.login_password"), type: "warning" },
  WARN_MATCH_PASSWORD: { message: i18next.t("toast.account.warn.match_password"), type: "warning" },
  WARN_UPDATE_NEW_PASSWORD: { message: i18next.t("toast.account.warn.update_new_password"), type: "warning" },
  WARN_TOO_SHORT: { message: i18next.t("toast.account.warn.too_short"), type: "warning" },
  WARN_SHIPPING_ADDRESS: { message: i18next.t("toast.account.warn.shipping_address"), type: "warning" },
  WARN_PHONE_VALID: { message: i18next.t("toast.account.warn.phone_valid"), type: "warning" },
  WARN_PHONE_TAKEN: { message: i18next.t("toast.account.warn.phone_taken"), type: "warning" },
  WARN_PHONE_VERIFY: { message: i18next.t("toast.account.warn.phone_verify"), type: "warning" },
  WARN_BIRTH_VALID: { message: i18next.t("toast.account.warn.birth_valid"), type: "warning" },
  WARN_INVALID_CREDENTIALS: { message: i18next.t("toast.account.warn.invalid_credentials"), type: "warning" },
  WARN_ACCOUNT_TAKEN: { message: i18next.t("toast.account.warn.account_taken"), type: "warning" },
  WARN_EMAIL_ACCOUNT: { message: i18next.t("toast.account.warn.email_account"), type: "warning" },
  WARN_NO_LOGIN: { message: i18next.t("toast.account.warn.no_login_title"), type: "warning" },
  WARN_BLOCK_ACCOUNT: { message: i18next.t("toast.account.warn.block_account"), type: "warning" },
  WARN_NO_CART: { message: i18next.t("toast.account.warn.no_cart"), type: "warning" },

  // return
  WARNING_NO_REASON: {
    message: i18next.t("toast.return.warn.no_reason_title"),
    type: "warning",
  },
  WARNING_NO_DETAIL_REASON: {
    message: i18next.t("toast.return.warn.no_detail_reason_title"),
    type: "warning",
  },
  WARNING_NO_RETURN_PRODUCTS: {
    message: i18next.t("toast.return.warn.no_return_product"),
    type: "warning",
  },
  WARNING_NO_IMAGE: {
    message: i18next.t("toast.return.warn.no_image_title"),
    type: "warning",
  },
  WARNING_NO_PRODUCT: {
    message: i18next.t("toast.return.warn.remove_product_title"),
    type: "warning",
  },
  WARNING_OVER_PRODUCT: {
    message: i18next.t("toast.return.warn.over_product_title"),
    type: "warning",
  },

  WARN_UNDEFINED: { message: i18next.t("toast.account.warn.undefined"), type: "warning" },
  WARN_END_SESSION: { message: i18next.t("toast.account.warn.end_session"), type: "warning" },
  WARN_REQUEST_LOGIN: { message: i18next.t("toast.account.warn.request_login"), type: "warning" },
  WARN_NO_ACCESS: { message: i18next.t("toast.account.warn.has_no_access"), type: "warning" },
  WARN_RESET_PASSWORD: { message: i18next.t("toast.account.warn.password_reset_social_email"), type: "warning" },
  WARN_SOCIAL_ACCOUNT: (social: TOptions) => ({
    message: i18next.t("toast.account.warn.social_account", social),
    type: "warning",
  }),
  WARN_SOCIAL_ACCOUNT_TAKEN: (social: TOptions) => ({
    message: i18next.t("toast.account.warn.social_account_taken", social),
    type: "warning",
  }),

  // error
  ERROR_REGISTER_LIMIT: { message: i18next.t("toast.account.error.register_limit"), type: "error" },
  ERROR_UNIDENTIFIED_CUSTOMER: { message: i18next.t("toast.account.error.unidentified_customer"), type: "error" },
  ERROR_UNIDENTIFIED_PHONE: { message: i18next.t("toast.account.error.unidentified_phone"), type: "error" },

  ERROR_RETURN: {
    message: i18next.t("toast.return.error.failed_return"),
    type: "error",
  },
  ERROR_NO_RETURN_PRODUCT: {
    message: i18next.t("toast.return.error.failed_no_return_product"),
    type: "error",
  },
  ERROR_ALREADY_DELETE_ACCOUNT: { message: i18next.t("toast.account.error.already_delete_account"), type: "error" },

  ERROR_SERVER: { message: i18next.t("toast.account.error.server_error"), type: "error" },
  ERROR_DISCOUNT_CODE_API_FAILED: {
    message: i18next.t("toast.checkout.error.failed_api_discount_code"),
    type: "error",
  },
  ERROR_DISCOUNT_CODE: { message: i18next.t("toast.checkout.error.discount_code_title"), type: "error" },
  ERROR_ALREADY_USED_DISCOUNT_CODE: {
    message: i18next.t("toast.checkout.error.already_used_discount_code_title"),
    type: "error",
  },
  // success
  SUCCESS_REGISTER: { message: i18next.t("toast.account.success.register"), type: "success" },
  SUCCESS_LOGIN: { message: i18next.t("toast.account.success.login"), type: "success" },
  SUCCESS_LOGOUT: { message: i18next.t("toast.account.success.logout"), type: "success" },
  SUCCESS_VERIFY: { message: i18next.t("toast.account.success.verify"), type: "success" },
  SUCCESS_PASSWORD_RESET: (email: TOptions) => ({
    message: i18next.t("toast.account.success.password_reset", email),
    type: "success",
  }),
  SUCCESS_PASSWORD_CHANGED: { message: i18next.t("toast.account.success.password_changed"), type: "success" },
  SUCCESS_DISABLE_CUSTOMER: { message: i18next.t("toast.account.success.disable_customer"), type: "success" },
  SUCCESS_MODIFY_ACCOUNT_INFO: { message: i18next.t("toast.account.success.modify_account_info"), type: "success" },

  /** product */
  SUCCESS_COPY_URL: { message: i18next.t("toast.product.success.copy_url"), type: "success" },
  WARN_SELECT_SIZE: { message: i18next.t("toast.product.warn.select_size"), type: "warning" },
  ERROR_EXCEED_QTY: { message: i18next.t("toast.product.error.exceed_qty"), type: "error" },

  /** wishlist */
  SUCCESS_ADD_WISH_ITEM: { message: i18next.t("toast.wishlist.success.add_wish_item"), type: "success" },
  SUCCESS_DELETE_WISH_ITEM: { message: i18next.t("toast.wishlist.success.delete_wish_item"), type: "success" },

  /** draw */
  SUCCESS_ENTRY: { message: i18next.t("toast.draw.success.entry"), type: "success" },
  WARN_ENTRY_SHIPPING_ADDRESS_EMPTY: {
    message: i18next.t("toast.draw.warn.entry_shipping_address_empty"),
    type: "warning",
  },
  WARN_ENTRY_INSTAGRAM: { message: i18next.t("toast.draw.warn.entry_instagram"), type: "warning" },
  WARN_CHECK_AGREEMENT: { message: "드로우 이용 약관에 동의해 주세요.", type: "warning" },
  WARN_CHECK_CARD_EMPTY: { message: "결제 수단을 등록해 주세요.", type: "warning" },
  WARN_CHECK_CARD: { message: "자동 결제에 등록할 카드를 선택해 주세요.", type: "warning" },

  /** checkout */
  WARN_CHECKOUT_SHIPPING_ADDRESS_EMPTY: {
    message: i18next.t("toast.checkout.warn.checkout_shipping_address_empty"),
    type: "warning",
  },
  WARN_DISCOUNT_CODE_EMPTY: { message: i18next.t("toast.checkout.warn.discount_code_valid"), type: "warn" },

  ERROR_DISCOUNT_CODE_VALID: { message: i18next.t("toast.checkout.error.discount_code_valid"), type: "error" },
  ERROR_PAYMENT_INFO: { message: i18next.t("toast.checkout.error.payment_info"), type: "error" },
  ERROR_PAYMENT_SET: { message: i18next.t("toast.checkout.error.payment_set"), type: "error" },
  ERROR_PAYMENT_COMPLETE: { message: i18next.t("toast.checkout.error.payment_complete"), type: "error" },
  ERROR_PAYMENT_CANCEL: { message: i18next.t("toast.checkout.error.payment_cancel"), type: "error" },

  INFO_SALE_10: { message: i18next.t("toast.checkout.info.sale_10"), type: "info" },

  WARN_SELECT_LETTER: { message: i18next.t("toast.captcha.warn.select_letter"), type: "warning" },
  WARN_SELECT_WRONG_LETTER: { message: i18next.t("toast.captcha.warn.select_wrong_letter"), type: "warning" },
  WARN_WRITE_WRONG_LETTER: { message: i18next.t("toast.captcha.warn.write_wrong_letter"), type: "warning" },
  SUCCESS_SELECT_LETTER: { message: i18next.t("toast.captcha.success.select_letter"), type: "success" },
};
